import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ButtonWrap from "../../components/template/ButtonWrap"
import MainTitle from "../../components/template/MainTitle"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"
import { useState } from "react"
import EvaluationTestsetSelector from "./EvaluationTestsetSelector"
import NewInfoFormat from "../../components/template/NewInfoFormat"
import EvaluaitonComparisonColumns from "./EvaluaitonComparisonColumns"
import PageDescription from "../../components/template/PageDescription"

const EvaluationComparisonPage = () => {
    const [testset, setTestset] = useState()
    const navigate = useNavigate()
    return (
        <div className='default-background'>
            <div className="flex justify-between items-center my-5">
                <MainTitle title="Evaluation Comparison" />
                <ButtonWrap contents={<FontAwesomeIcon icon={faArrowLeft} />} onClick={() => navigate('/')} />
            </div>
            <div className="mb-4">
                <PageDescription contents={[
                    "On this page, you can compare evaluation results side by side — pick a testset (benchmarks included) and add the evaluations you want to compare.",
                ]} />
            </div>
            <NewInfoFormat label="Testset" description={<></>} contents={<EvaluationTestsetSelector testset={testset} setTestset={setTestset} />} />
            {testset && <EvaluaitonComparisonColumns testset={testset} />}
        </div>)
}

export default EvaluationComparisonPage